import { IonButtons, IonContent, IonHeader, IonMenuButton, IonPage, IonTitle, IonToolbar, IonCol, IonRow } from '@ionic/react';
import { useParams } from 'react-router';
import ExploreContainer from '../components/ExploreContainer';
import { Descriptions, Row, Col, notification } from 'antd';
import { Card } from 'antd';
import { Switch } from 'antd';
import { Input } from 'antd';
import moment from 'moment';
import { PageHeader } from 'antd';


import { DatePicker, Space ,Button} from 'antd';

import React, { useState } from 'react';

const Admin: React.FC = (props:any) => {

return( 

<>























</>

    );
}

export default Admin;